// Settings and the clock. The clock and the settings are also used by the top bar, the overview, the Test tools and
// the new-audience form (through index.ts); saving belongs to the Settings screen only.
import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'
import type { SaveSettingsInput } from '@/api/schemas'
import { useChange } from '@/api/useChange'

const keys = { clock: ['clock'] as const, settings: ['settings'] as const }

export function useClock() {
  const api = useApi()
  return useQuery({ queryKey: keys.clock, queryFn: () => api.getClock() })
}

export function useSettings() {
  const api = useApi()
  return useQuery({ queryKey: keys.settings, queryFn: () => api.getSettings() })
}

export const useSaveSettings = () => useChange((api, input: SaveSettingsInput) => api.saveSettings(input))
